import React from 'react';
import Swal from 'sweetalert2';
import { connect } from 'react-redux';
import { Form, FormGroup, Input, Button } from 'reactstrap';

//Componentes auxiliares:
import CustomModal from '../../../tools/components/CustomModal';

let PasswordResetModal = (props) => {
    return (
        <CustomModal isTheModalOpen={props.isOpen} modalToggle={props.modalToggle}
            size="md" title={getModalTitle()} centered footerButtons={[
                <Button color="info" key="changePasswordSubmitButton" onClick={() => {
                    try {
                        document.getElementById("resetPasswordSubmitButton").click();
                    }
                    catch (error) { console.log(error); }
                }}>Recuperar contraseña</Button>
            ]} >

            <Form style={{ marginTop: 25, marginBottom: 0 }}
                onSubmit={(e) => {
                    e.preventDefault();

                    if (e.target.targetEmail.value !== "") {
                        fetch(process.env.REACT_APP_API_URL + '/users/generateResetToken', {
                            method: 'POST',
                            headers: { 'Content-Type': 'application/json' },
                            body: JSON.stringify({ 'email': e.target.targetEmail.value })
                        })
                            .then(serverResponse => {
                                switch (serverResponse.status) {
                                    case 200:
                                        fireSuccessPasswordChangeAlert();
                                        break;

                                    default:
                                        fireFailedPasswordChangeAlert();
                                        break;
                                }
                            })
                            .catch(error => { console.log(error); fireFailedPasswordChangeAlert(); });
                    }

                }}>
                <FormGroup>
                    <p>Para continuar, digita tu correo electrónico:</p>
                    <div style={{ paddingLeft: "15%", paddingRight: "15%" }}>
                        <Input type="email" name="email" id="targetEmail" placeholder="Tu correo electrónico" required />
                    </div>
                </FormGroup>

                <Button className="not-visible-button" id="resetPasswordSubmitButton" />
            </Form>

        </CustomModal>

    );
}

let fireFailedPasswordChangeAlert = () => {
    Swal.fire('Proceso fallido', 'Se presentó un error crítico en la solicitud de <b>cambio de contraseña</b>. Intenta más tarde.', 'error');
}

let fireSuccessPasswordChangeAlert = () => {
    Swal.fire('Proceso exitoso', 'Revisa tu bandeja de <b>correo electrónico</b> para continuar.', 'success');
}

let getModalTitle = () => {
    return (
        <p style={{ marginBottom: 5, textTransform: "capitalize" }}>
            Recuperar
            <span style={{ textTransform: "none", marginLeft: 5 }}>
                <b>contraseña</b>
            </span>
        </p>
    );
}

const mapStateToProps = state => {
    return { coreBackendHost: state.mainReducer.coreBackendHost };
};

export default connect(mapStateToProps)(PasswordResetModal);